<mat-dialog-content class="dialog">
  <div class="close-button-container">
    <app-modal-close-button
      [closeDialog]="closeDialog.bind(this)"></app-modal-close-button>
  </div>
  <div class="dialog-content">
    <div class="dialog-header">
      <div class="resident-info">
        <app-profile-avatar
          [image]="selectedResidentImage"
          [name]="selectedResident.getName()"
          [color]="selectedResident.color"
          [size]="70"></app-profile-avatar>
        <div class="resident-base-info">
          <p class="room" *ngIf="selectedResident?.roomNumber">
            ZIMMER {{ selectedResident?.roomNumber }}
          </p>
          <p class="name">
            {{ this.selectedResidentName }}
          </p>
        </div>
      </div>
      <div>
        <p class="cart-sum">
          {{ cartItemsCount }} Produkte |
          <span class="cart-total">€ {{ cartTotal | number: '1.2-2' }}</span>
        </p>
      </div>
    </div>
    <div class="dialog-body">
      <app-empty-list-info
        *ngIf="cartItemsCount === 0"
        [text]="noProductsText"></app-empty-list-info>
      <app-cart-products-table
        *ngIf="cartItemsCount > 0"
        [dataSource]="products"
        [residentId]="selectedResident.id"></app-cart-products-table>
      <!-- <div class="check-bag-container">
        <p>Tüte abschließen</p>
        <app-slide-toggle
          (toggleClicked)="onSliderClick()"
          class="slider"></app-slide-toggle>
      </div> -->
    </div>
    <div
      class="dialog-footer"
      *ngIf="permissionsService.canAddProductsToCart()">
      <div class="empty-cart-container" (click)="showEmptyCartConfirmation()">
        <span class="empty-cart-text">Tüte leeren</span>
        <mat-icon svgIcon="trash-icon" class="trash-icon"></mat-icon>
      </div>
    </div>
  </div>
</mat-dialog-content>
